import DateTime, { Parser } from '@dealroadshow/uikit-date-time';
import { IFileUploadNotificationSettingsPayload } from './domain/vo/FileUploadEmailAlerts';
import {
  IStagingFileUploadNotificationSettingsPayload,
} from './domain/vo/StagingFileUploadEmailAlerts';
import { IDigestNotificationSettingsPayload } from './domain/vo/DigestEmailAlerts';
import { IAccessRequestNotificationSettingsPayload } from './domain/vo/AccessRequestEmailAlerts';
import { IQuestionsNotificationSettingsPayload } from './domain/vo/QuestionsEmailAlerts';
import type { IndeterminateValue } from './domain/vo/IndeterminateValue';

const getShortTime = (time: string): string => (
  new DateTime(time, { parsers: [new Parser({ format: 'H:mm:ss' })] }).format('ha')
);

export const getNotificationSummary = (
  values: IFileUploadNotificationSettingsPayload |
    IStagingFileUploadNotificationSettingsPayload |
    IAccessRequestNotificationSettingsPayload,
  abbr: string,
) => {
  if (!values) return 'None';

  const result: string[] = [];

  if (values.isRealTime) {
    result.push('Real-time');
  }

  if (values.isDaily) {
    result.push(`Daily at ${ getShortTime(values.dailyTime) } ${ abbr }`);
  }

  if (values.isWeekly) {
    result.push(`Weekly on ${ values.weeklyDay } at ${ getShortTime(values.weeklyTime) } ${ abbr }`);
  }

  return result.length ? result.join('; ') : 'None';
};

export const getDigestNotificationSummary = (
  values: IDigestNotificationSettingsPayload,
  abbr: string,
) => {
  if (!values) return 'None';

  const result: string[] = [];

  if (values.isDigestDaily) {
    result.push(`Daily at ${ getShortTime(values.digestDailyTime) } ${ abbr }`);
  }

  if (values.isDigestWeekly) {
    result.push(`Weekly on ${ values.digestWeeklyDay } at ${ getShortTime(values.digestWeeklyTime) } ${ abbr }`);
  }

  return result.length ? result.join('; ') : 'None';
};

export const getQuestionNotificationSummary = (
  values: IndeterminateValue<IQuestionsNotificationSettingsPayload>,
  abbr: string,
) => {
  if (!values) return 'None';

  const result: string[] = [];

  if (values.isQuestionRealTime) {
    result.push('Real-time');
  }

  if (values.isQuestionDaily && values.questionDailyTime?.length) {
    result.push(`Daily at ${ getShortTime(values.questionDailyTime) } ${ abbr }`);
  }

  if (values.isQuestionWeekly) {
    result.push(`Weekly on ${ values.questionWeeklyDay } at ${ getShortTime(values.questionWeeklyTime) } ${ abbr }`);
  }

  return result.length ? result.join('; ') : 'None';
};
